import { removeOption as c } from "../../helpers.js";
const a = ({
  selectedValue: n,
  onChange: i,
  searchValue: s,
  maxSelected: r
}) => ({
  onItemClick: (o, t) => {
    s || t.stopPropagation();
    const e = n.some((u) => u.value === o.value);
    if (!e && r && n.length >= r)
      return;
    const m = e ? c(n, o) : [...n, o];
    i(m);
  },
  isSelected: (o) => n.some((t) => t.value === o.value)
});
export {
  a as useMenuList
};
